import React, {useEffect, useRef, useState} from "react";
import {
    IonButton,
    IonCol,
    IonContent,
    IonGrid, IonIcon,
    IonItem, IonLabel,
    IonList, IonMenu,
    IonMenuToggle,
    IonRouterOutlet,
    IonRow,
    IonSplitPane
} from "@ionic/react";
import useAuth from "../hooks/useAuth";
import {convertMinutesToReadableTime} from "../utils";
import {
    batteryDeadOutline,
    batteryDeadSharp,
    batteryFullOutline,
    batteryFullSharp,
    batteryHalfOutline,
    batteryHalfSharp, clipboardOutline, clipboardSharp, code,
    constructOutline,
    constructSharp, gridOutline, gridSharp, medkitOutline, medkitSharp,
    megaphoneOutline,
    megaphoneSharp, peopleOutline, peopleSharp,
    personOutline,
    personSharp, pricetagOutline, pricetagsOutline, pricetagsSharp,
    statsChartOutline, statsChartSharp
} from "ionicons/icons";
import {useLocation} from "react-router-dom";
import moment from "moment";



interface AppPage {
    url: string;
    iosIcon: string;
    mdIcon: string;
    title: string;
    rule?: string;
    subMenuUser?: boolean;
}

const appPages: AppPage[] = [
    {
        title: 'Announcements',
        url: '/announcements',
        iosIcon: megaphoneOutline,
        mdIcon: megaphoneSharp
    }, {
        title: 'User Manager',
        url: '/user-manager',
        iosIcon: personOutline,
        mdIcon: personSharp,
        rule: 'CanAdminUsers',
        subMenuUser: true
    }, {
        title: 'Reports Manager',
        url: '/reports-manager',
        iosIcon: constructOutline,
        mdIcon: constructSharp,
        rule: 'CanAdminReports'
    }, {
        title: 'Reports',
        url: '/reports',
        iosIcon: statsChartOutline,
        mdIcon: statsChartSharp,
        rule: 'CanSeeReports'
    }, {
        title: 'Grid Manager',
        url: '/grid-manager',
        iosIcon: gridOutline,
        mdIcon: gridSharp,
        rule: 'CanSeeGridManager'
    }, {
        title: 'Dashboard',
        url: '/dashboard',
        iosIcon: clipboardOutline,
        mdIcon: clipboardSharp,
        rule: 'CanSeeDashboard'
    }, {
        title: 'Dev Tools',
        url: '/dev-tools',
        iosIcon: code,
        mdIcon: code,
        rule: 'CanAccessDevTools'
    },
    {
        title: 'ACA Healthcare',
        url: '/aca',
        iosIcon: medkitSharp,
        mdIcon: medkitOutline,
        rule: 'AcaView'
    }
];


const ViaSplitPane: React.FC<any> = ({ children }) => {
    const location = useLocation();
    const { token, tokenExpiration, onLogout, email, claims, onMouseDownEvent, isSSO } = useAuth();
    const menuRef = useRef<HTMLIonMenuElement>(null);

    const [currTime, setCurrTime] = useState<number>();
    const [showMenu, setShowMenu] = React.useState<boolean>(false);
    useEffect(() => {
        if (token) {
            setShowMenu(true);
        } else {
            setShowMenu(false);
        }
    }, [token]);
    useEffect(() => {
        if (tokenExpiration) {
            setCurrTime(Math.floor(moment(tokenExpiration).diff(moment()) / (1000 * 60)));
        }
    }, [tokenExpiration]);

    return (
        <IonSplitPane contentId="main" onMouseDown={onMouseDownEvent}>

                <IonMenu ref={menuRef} type="overlay" contentId="main" className={showMenu && !isSSO ? "fullmenu" : "hiddenmenu"}>
                <IonContent>

                        <IonGrid style={{height: '100%', display: 'grid'}}>
                            <IonRow>
                                <IonCol>
                                    <img src="/assets/logo-ams.png" width={200} height={70} />
                                    <IonList>
                                        {token && appPages.map((appPage, index) => {
                                                if (appPage.rule === undefined || claims.rules.includes(appPage.rule)) {
                                                    return (
                                                        <IonMenuToggle key={index} autoHide={false}>
                                                            <IonItem className={location.pathname.split('/')[1] === appPage.url.split('/')[1] ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                                                                <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon}/>
                                                                <IonLabel>{appPage.title}</IonLabel>
                                                            </IonItem>

                                                            {appPage.subMenuUser && location.pathname.split('/')[1] === appPage.url.split('/')[1] &&
                                                                <>
                                                                    <IonItem className={'user-manager' === location.pathname.split('/').pop() ? 'selected': ''} style={{marginLeft: '20px'}} routerLink={'/user-manager'} routerDirection="none" lines="none" detail={false}>
                                                                        <IonIcon slot="start" ios={peopleOutline} md={peopleSharp}/>
                                                                        <IonLabel>Users</IonLabel>
                                                                    </IonItem>
                                                                    <IonItem className={'roles' === location.pathname.split('/').pop() ? 'selected': ''} style={{marginLeft: '20px'}} routerLink={'/user-manager/roles'} routerDirection="forward" lines="none" detail={false}>
                                                                        <IonIcon slot="start" ios={pricetagsOutline} md={pricetagsSharp}/>
                                                                        <IonLabel>Roles</IonLabel>
                                                                    </IonItem>
                                                                    <IonItem className={'rules' === location.pathname.split('/').pop() ? 'selected': ''} style={{marginLeft: '20px'}} routerLink={'/user-manager/rules'} routerDirection="none" lines="none" detail={false}>
                                                                        <IonIcon slot="start" ios={pricetagOutline} md={pricetagOutline}/>
                                                                        <IonLabel>Rules</IonLabel>
                                                                    </IonItem>
                                                                </>
                                                            }
                                                        </IonMenuToggle>
                                                    );
                                                }
                                            }
                                                )
                                            }
                                    </IonList>
                                </IonCol>
                            </IonRow>
                            <IonRow class="ion-align-self-end">
                                <IonCol>
                                    <div style={{textAlign: 'center'}}>
                                        <div style={{display: 'inline-block'}}>
                                            {currTime && (currTime / 720 > .75) &&
                                                <IonLabel title={'Session Expiration: ' + convertMinutesToReadableTime(currTime)} class="sessionExpiration" style={{paddingRight: '10px'}}>
                                                    <IonIcon style={{color: "black"}} md={batteryFullOutline} ios={batteryFullSharp}></IonIcon>
                                                </IonLabel>
                                            }
                                            {currTime && (currTime / 720 <= .75) && (currTime > .5) &&
                                                <IonLabel title={'Session Expiration: ' + convertMinutesToReadableTime(currTime)} class="sessionExpiration" style={{paddingRight: '10px'}}>
                                                    <IonIcon style={{color: "black"}} md={batteryHalfOutline} ios={batteryHalfSharp}></IonIcon>
                                                </IonLabel>
                                            }
                                            {currTime && (currTime <= .5) &&
                                                <IonLabel title={'Session Expiration: ' + convertMinutesToReadableTime(currTime)} class="sessionExpiration" style={{paddingRight: '10px'}}>
                                                    <IonIcon style={{color: "black"}} md={batteryDeadOutline} ios={batteryDeadSharp}></IonIcon>
                                                </IonLabel>
                                            }
                                        </div>
                                        {email && <div style={{marginTop: 10, textAlign: 'center', display: 'inline-block'}}>
                                            <IonIcon ios={personOutline} md={personSharp} style={{
                                                position: 'relative',
                                                top: 2
                                            }}/> {email.split("@")[0]}
                                        </div>}
                                    </div>
                                    {token && <IonMenuToggle key={"logout_btn"} autoHide={false}><IonButton expand="full" onClick={onLogout}>Logout</IonButton></IonMenuToggle>}
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                </IonContent>
            </IonMenu>
            <IonRouterOutlet id="main">
                {children}
            </IonRouterOutlet>
        </IonSplitPane>
    );
};


export default ViaSplitPane;